import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=15671ae6&scoped=true&lang=pug&"
import script from "./ClientHeader.vue?vue&type=script&lang=js&"
export * from "./ClientHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClientHeader.vue?vue&type=style&index=0&id=15671ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15671ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
